"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var store_1 = require("../store");
var toArray = function (value) {
    if (value) {
        return Array.isArray(value) ? value : [value];
    }
    return [];
};
var hasAnyPermission = function (keys, permissions) {
    return keys.some(function (k) { return permissions.indexOf(k) >= 0; });
};
var usePermission = function (permissionKey) {
    var permissions = store_1.useStore(function (store) { return store.permission.permissions; });
    var hasPermission = react_1.useMemo(function () {
        var keys = toArray(permissionKey);
        if (permissionKey && permissions && permissions.length > 0) {
            var result = hasAnyPermission(keys, permissions);
            return result;
        }
        return true;
    }, [permissions, permissionKey]);
    return [hasPermission];
};
exports.default = usePermission;
